import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '../services';
import { filter, firstValueFrom } from 'rxjs';
import { OrgMember } from '@zagops/api/sdk-angular';

export const isOnboarded: CanActivateFn = async (): Promise<boolean> => {
  const router: Router = inject(Router);
  const userService: UserService = inject(UserService);

  const appUser = await firstValueFrom(
    userService.appUser$.pipe(filter((appUser) => appUser.user !== undefined)),
  );

  const userIsOnboarded = !!appUser.orgMembers?.filter(
    (om) => om.status === OrgMember.status.ACTIVE,
  ).length;

  if (!userIsOnboarded) await router.navigate(['/onboarding']);

  return userIsOnboarded;
};

export const isOnboardedChild: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => isOnboarded(route, state);
